import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { BaseTransformer } from './BaseTransformer';
import moment from "moment";
export var ActTaskTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ActTaskTransformer, _BaseTransformer);
  var _super = _createSuper(ActTaskTransformer);
  function ActTaskTransformer() {
    _classCallCheck(this, ActTaskTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ActTaskTransformer, null, [{
    key: "fetch",
    value: function fetch(data, users) {
      var followers = data.followers;
      var followers_array = null;
      // console.log("followers",followers)
      if (followers && _typeof(followers) == "object" && followers[0]) {
        followers_array = followers.map(function (k) {
          return k.id ? parseInt(k.id.substr(1)) : null;
        });
        if (users) {
          data.followers = followers.map(function (u) {
            var user = users.find(function (uf) {
              return "U" + uf.value == u.id;
            });
            if (user) {
              u.letters = user.firstname ? user.firstname.substring(0, 1) + user.lastname.substring(0, 1) : '';
              u.value = parseInt(u.id.substr(1));
              u.photo = user ? user.photo : '';
              u.full_name = user ? user.fullName : '';
              return u;
            } else {
              u.value = parseInt(u.id.substr(1));
              var lastname = u.label.split(" ")[1];
              u.letters = u.label ? u.label.substring(0, 1) + (lastname ? lastname.substring(0, 1) : '') : '';
              return u;
            }
          });
        }
      } else if (followers && typeof followers == "string") {
        followers_array = followers.split(',');
      }
      data.expected_duration = Math.round(data.expected_duration * 60);
      return {
        task_type: {
          value: data.task_type ? data.task_type.value : null,
          label: data.task_type ? data.task_type.label : null
        },
        section: {
          value: data.section ? data.section.value : null,
          label: data.section ? data.section.label : null
        },
        account_name: {
          value: data.account_name ? data.account_name.value : null,
          label: data.account_name ? data.account_name.label : null
        },
        priority: {
          value: data.priority ? data.priority.value : null,
          label: data.priority ? data.priority.label : null
        },
        dependency: {
          value: data.dependency ? data.dependency.value : null,
          label: data.dependency ? data.dependency.label : null
        },
        followers: data.followers,
        project: {
          value: data.project ? data.project.value : null,
          label: data.project ? data.project.label : null
        },
        thread: {
          value: data.thread ? data.thread.value : null,
          label: data.thread ? data.thread.label : null
        },
        record_owner: {
          value: data.record_owner ? data.record_owner.value : null,
          label: data.record_owner ? data.record_owner.label : null
        },
        task_status: {
          value: data.task_status ? data.task_status.value : null,
          label: data.task_status ? data.task_status.label : null
        },
        // task_status_customValue:  data.relatedData && data.relatedData.task_status.customValue ? data.relatedData.task_status.customValue : '',
        followers_array: followers_array,
        visible_on_cp: data.visible_on_cp ? true : false,
        record_id: data.record_id,
        rescheduling_reason: data.rescheduling_reason,
        due_date_scheduled_on: data.due_date_scheduled_on,
        spent_time: data.spent_time,
        hold_reason: data.hold_reason,
        created_on: data.created_on,
        created_by: {
          value: data.created_by ? data.created_by.value : null,
          label: data.created_by ? data.created_by.label : null
        },
        last_modified_on: data.last_modified_on,
        last_modified_by: {
          value: data.last_modified_by ? data.last_modified_by.value : null,
          label: data.last_modified_by ? data.last_modified_by.label : null
        },
        overdue_duration: data.overdue_duration,
        support_assignees: data.support_assignees,
        dependency_count: data.dependency_count,
        subject: data.subject,
        expected_duration: data.expected_duration ? data.expected_duration : 0,
        allday: data.allday,
        photo: data.photo,
        task_results: data.task_results,
        noteCount: data.noteCount,
        attachmentCount: data.attachmentCount,
        description: data.description,
        section__content: data.section__content,
        sub_tasks: data.sub_tasks,
        customer_comments_count: data.customer_comments_count,
        customer_comments_done: data.customer_comments_done,
        start_date: data.start_date,
        end_date: data.end_date,
        dateRange: [data.start_date, data.end_date],
        end_date_dmy: data.end_date ? moment(data.end_date).format("YYYY-MM-DD") : '',
        start_date_dmy: data.start_date ? moment(data.start_date).format("YYYY-MM-DD") : '',
        relatedData: data.relatedData,
        project__project_status: data.project__project_status,
        project__record_owner: data.project__record_owner
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        // record_id: data.recordId,
        // calendar:  data.calendar && data.calendar.value ? data.calendar.value :  data.calendar ?  data.calendar : '',
        // subject: data.subject,
        // activity_status: data.activityStatus ? data.activityStatus.value : null,
        // location: data.location ? data.location : '',
        // location_coords: data.locationCoords ? data.locationCoords : '',
        // start_date: start,
        // end_date: end,
        // planned_start_date: start,
        // planned_end_date: end,
        // deal:  data.deal ? data.deal : '',
        // activity_notes: data.activityNotes ? data.activityNotes : '',
        // description: data.description ? data.description : '',
        // record_owner: data.recordOwner ? data.recordOwner.value : null,
        // project_status: data.projectStatus ? data.projectStatus.value : null,
        // project: data.project ? data.project.value : null, 
      };
    }
  }]);
  return ActTaskTransformer;
}(BaseTransformer);